import { useDocumentTitle } from "hooks/useDocumentTitle";
import { FC } from "react";
import SectionGridFilterCard from "./SectionGridFilterCard";
import BgGlassmorphism from "designs/DesignB/components/BgGlassmorphism/BgGlassmorphism";
import BackRouteButton from "shared/BackRouteButton/BackRouteButton";
import { useData } from "data/data-provider";

export interface ListingCarPageProps {
  className?: string;
}

const AvailableCarsPage: FC<ListingCarPageProps> = ({ className = "" }) => {
  const { companyDetails } = useData();
  const companyName = companyDetails?.company_name || "Car rental";
  useDocumentTitle(companyName ? `${companyName} || Car rental` : undefined);
  return (
    <div
      className={`nc-ListingCarPage relative overflow-hidden ${className}`}
      data-nc-id="ListingCarPage"
    >
      <BgGlassmorphism />

      <div className="container relative">
        <div className="mt-2">
          <BackRouteButton />
        </div>
        <SectionGridFilterCard className="mt-12 pb-24 lg:pb-28" />
      </div>
    </div>
  );
};

export default AvailableCarsPage;
